import { useEffect, useRef, useState } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;
const SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let loader = null;

const loadScript = () => {
  if (!loader) {
    loader = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = SRC;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return loader;
};

export const useTurnstile = () => {
  const ref = useRef(null);
  const widgetId = useRef(null);
  const [token, setToken] = useState("");
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!SITE_KEY) return undefined;
    let cancelled = false;
    loadScript()
      .then(() => {
        if (cancelled || !ref.current || !window.turnstile) return;
        widgetId.current = window.turnstile.render(ref.current, {
          sitekey: SITE_KEY,
          appearance: "interaction-only",
          callback: (t) => { setFailed(false); setToken(t); },
          "expired-callback": () => setToken(""),
          "error-callback": () => { setToken(""); setFailed(true); },
        });
      })
      .catch(() => setFailed(true));
    return () => {
      cancelled = true;
      if (widgetId.current != null) window.turnstile?.remove(widgetId.current);
      widgetId.current = null;
    };
  }, []);

  const reset = () => {
    setToken("");
    if (widgetId.current != null) window.turnstile?.reset(widgetId.current);
  };

  return { enabled: Boolean(SITE_KEY), token, failed, ref, reset };
};
